import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password)
  }
`

export const CHECK_TOKEN = gql`
  mutation CheckToken($token: String!) {
    checkToken(token: $token)
  }
`
